import getOrFetch, { Referential } from '../Cache/Cache';

export type { Referential } from '../Cache/Cache';

export const ACQUIRERS = 'ACQUIRERS';
export const BRANCHES = 'BRANCHES';
export const CURRENCIES = 'CURRENCIES';
export const ENDPOINTS = 'ENDPOINTS';
export const GATEWAYS = 'GATEWAYS';
export const PRODUCTS = 'PRODUCTS';
export const SERVICES = 'SERVICES';
export const PAYMENT_METHODS = 'PAYMENT_METHODS';

export type Branch = Referential & {
	business: string;
	context: number;
	state: string;
	technicalName: string;
};

export type ReferentialType =
	| 'ACQUIRERS'
	| 'BRANCHES'
	| 'CURRENCIES'
	| 'ENDPOINTS'
	| 'GATEWAYS'
	| 'PRODUCTS'
	| 'SERVICES'
	| 'PAYMENT_METHODS';

export type ProductGroup =
	| 'MONEY'
	| 'ACCORVOUCHER'
	| 'COUPONNING'
	| 'SCHOOLMONEY'
	| 'MONIZZEVOUCHER'
	| 'EKENAVOUCHER'
	| 'CREDITMONEY'
	| 'MONIZZEECOCHEQUE'
	| 'MONIZZEGIFTVOUCHER'
	| 'MONIZZECONSUMPTIONVOUCHER';

export type Acquirer = Referential & {
	unifiedModel: boolean;
};

export type Product = Referential & {
	group: number;
	currency: string;
	displayPrecision: number;
};

export type Currency = Referential & {
	product: number;
	currency: string;
	sign: string;
	numeric: number;
};

export type Service = Referential & {
	optionGroup: string;
};

export type Gateway = Referential & {
	externalName: string;
};

export type PaymentMethod = Referential;

export const getAcquirers = async (addEmptyValue = false): Promise<Acquirer[]> =>
	getOrFetch<Acquirer>(ACQUIRERS, '/CollectAPIService/v1/acquirers', addEmptyValue);

export const getServices = async (addEmptyValue = false): Promise<Service[]> =>
	getOrFetch<Service>(SERVICES, '/CollectAPIService/v1/services', addEmptyValue);

export const getBranches = (addEmptyValue = false): Promise<Branch[]> =>
	getOrFetch<Branch>(BRANCHES, '/PlatformAPIService/v1/branches', addEmptyValue);

export const getEndpoints = (addEmptyValue = false): Promise<Referential[]> =>
	getOrFetch(ENDPOINTS, '/PlatformAPIService/v1/endpoints', addEmptyValue);

export const getGateways = async (addEmptyValue = false): Promise<Gateway[]> =>
	getOrFetch<Gateway>(
		GATEWAYS,
		'/CollectAPIService/v1/gateways',
		addEmptyValue,
		'id',
		'externalName',
	);

export const getProducts = async (
	group: ProductGroup = 'MONEY',
	addEmptyValue = false,
): Promise<Product[]> =>
	getOrFetch<Product>(
		`${PRODUCTS}-${group}`,
		`/PlatformAPIService/v1/products/${group}`,
		addEmptyValue,
	);

export const getCurrencies = async (addEmptyValue = false): Promise<Currency[]> =>
	getOrFetch<Currency>(
		CURRENCIES,
		'/PlatformAPIService/v1/currencies',
		addEmptyValue,
		'numeric',
		'currency',
	);

export const getPaymentMethods = async (addEmptyValue = false): Promise<PaymentMethod[]> =>
	getOrFetch<PaymentMethod>(
		PAYMENT_METHODS,
		'/CollectAPIService/v1/payment-methods',
		addEmptyValue,
	);

export const getReferentialByType = (
	type: ReferentialType,
	group?: ProductGroup,
): Promise<Referential[]> => {
	switch (type) {
		case ACQUIRERS:
			return getAcquirers();
		case BRANCHES:
			return getBranches();
		case CURRENCIES:
			return getCurrencies();
		case ENDPOINTS:
			return getEndpoints();
		case GATEWAYS:
			return getGateways();
		case PRODUCTS:
			return getProducts(group as ProductGroup);
		case PAYMENT_METHODS:
			return getPaymentMethods();
		case SERVICES:
			return getServices();
		default:
			throw new Error(`Unknown referential type ${type}`);
	}
};
